<template>
  <div class="droplayer icon filter-box task-home-b relative">
    <v-menu offset-y :close-on-content-click="false" v-model="filterShow">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" :class="filterCount > 0 ? 'sel' : ''">필터</v-btn>
      </template>
      <div class="dropdown-list cnt board">
        <div class="dropdown-list_header">
          {{ $i18nUtil.trans("search.filter.001","{cnt}건 선택", {cnt: filterCount}) }}
          <button type="button" class="btn-refresh" v-if="filterCount > 0" @click="filterClear">새로고침</button>
        </div>
        <div class="cnt_inner clear">
          <div class="cnt-option">
            <div class="tit">{{ $i18nUtil.trans("message.filter.007","공간") }}</div>
            <ul>
              <li 
                v-for="(groupKbnItem, groupKbnItemIndex) in groupKbnList"
                :key="groupKbnItem.groupKbn + '_' + groupKbnItemIndex"
              >
                <input type="checkbox" name="" 
                  :id="`chkGroupKbnId`+groupKbnItemIndex" 
                  v-model="modelFilterGroupKbnList"
                  :value="groupKbnItem.groupKbn"
                /><label :for="`chkGroupKbnId`+groupKbnItemIndex">{{groupKbnItem.groupKbnName}}</label>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-list_foot">
          <button type="button" class="btn-primary-small" @click="recoverFilter">{{ $i18nUtil.trans("button.filter.cancel","취소") }}</button>
          <button type="button" class="btn-primary-small black" @click="applyFilter">{{ $i18nUtil.trans("button.filter.apply","적용") }}</button>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["filterReset"],
  data() {
    return {
      filterCount: 0,
      groupKbnList: [
          {groupKbn: 'PRO', groupKbnName: this.$i18nUtil.trans("entity.project","과제")}
        , {groupKbn: 'USER', groupKbnName: this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗")}
        , {groupKbn: 'SHAR', groupKbnName: this.$i18nUtil.trans("entity.cogroup.groupKbn.shar","정보공유")}
        , {groupKbn: 'CFRC', groupKbnName: this.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc","회의/협의")}
      ],
      prevModelFilterGroupKbnList: [],
      modelFilterGroupKbnList: [],
      filterShow: false,
      filterApply: false,
      tenantId: localStorage.getItem("tenantId"),
      // groupKbn: localStorage.getItem("groupKbn"),
    };
  },
  mounted(){
    if(this.tenantId == '418502' || this.tenantId == '203'){
      this.groupKbnList.splice(2, 2);
    }else if ( this.tenantId == '201'){
      this.groupKbnList.splice(1, 1);
    }
    // if(this.groupKbn != null){
    //   this.modelFilterGroupKbnList.push(this.groupKbn);
    //   this.prevModelFilterGroupKbnList.push(this.groupKbn);
    //   localStorage.removeItem("groupKbn");
    // }
  },
  watch: {
    filterShow: {
      handler() {
        let obj = this;
        // obj.groupKbn = null;
        setTimeout(()=> {
          if(!obj.filterShow && !obj.filterApply) {
            obj.modelFilterGroupKbnList = obj.prevModelFilterGroupKbnList;
          }
  
          if(obj.filterApply) {
            obj.filterApply = false;
          }
        }, 50);
      }
    },
    modelFilterGroupKbnList: {
      handler() {
        this.filterCount = this.modelFilterGroupKbnList.length;
      }
    },
    filterReset: {
      handler() {
        let obj = this;
        if(this.$props.filterReset) {
          obj.prevModelFilterGroupKbnList = [];
          obj.filterClear();
        }

      }
    }
  },
  methods: {
    // 필터 새로고침
    filterClear() {
      let obj = this;
      obj.modelFilterGroupKbnList = [];
    },
    // 필터 취소
    recoverFilter() {
      let obj = this;
      // 필터 되돌림
      obj.modelFilterGroupKbnList = obj.prevModelFilterGroupKbnList;
      obj.filterShow = false;
      obj.filterApply = false;
    },
    // 필터 적용
    applyFilter() {
      let obj = this;
      // 필터 변경
      obj.prevModelFilterGroupKbnList = obj.modelFilterGroupKbnList;
      obj.filterShow = false;
      obj.filterApply = true;
      let rtnGroupKbnList = obj.modelFilterGroupKbnList.length == 0 ? [] : obj.modelFilterGroupKbnList;
      
      if(obj.modelFilterGroupKbnList.length == 0) {
        obj.groupKbnList.forEach((elem)=> {
          rtnGroupKbnList.push(elem.groupKbn);
        });
      }
      
      obj.$emit('updateCooperationMemberBoardFilter', {filterGroupKbnList: rtnGroupKbnList});
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/filter/CooperationMemberBoardFilter.vue